module.exports = __webpack_public_path__ + "img/Apoptosis-ASHN_GSE227469.9f50f406.png";